import React from "react";
import Newra from "./Newra";

function Home(props) {
  return (
    <>
      <Newra outgoingApi={props.outgoingApi} />
    </>
  );
}

export default Home;
